import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, errMsg, TYPE_LABELS } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function History() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);

  useEffect(() => { if (user) api.get("/reviews").then((r) => setItems(r.data)); }, [user]);

  if (user === false) return <Navigate to="/login" replace />;

  const remove = async (id) => {
    if (!window.confirm("Delete this review? This cannot be undone.")) return;
    try {
      await api.delete(`/reviews/${id}`);
      setItems((x) => x.filter((r) => r.id !== id));
      toast.success("Review deleted");
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="max-w-6xl mx-auto px-6 pt-16" data-testid="history-page">
      <p className="eyebrow mb-4">History</p>
      <h1 className="font-serif-d text-5xl tracking-tight mb-12">Your reviews.</h1>
      {!items && <p className="eyebrow" data-testid="history-loading">Loading reviews...</p>}
      {items && items.length === 0 && (
        <div className="border border-dashed border-[var(--ink-3)] p-12 text-center" data-testid="history-empty">
          <p className="font-serif-d text-2xl mb-4">Nothing here yet.</p>
          <Link to="/new" className="btn-ink px-6 py-3 text-sm inline-block">Start your first review</Link>
        </div>
      )}
      <div className="border-t border-[var(--ink)]">
        {items?.map((r) => {
          const red = r.findings.filter((f) => f.severity === "red").length;
          return (
            <div key={r.id} className="group flex items-center gap-6 py-5 border-b border-[var(--rule)]" data-testid={`history-row-${r.id}`}>
              <Link to={`/reviews/${r.id}`} className="flex-1 min-w-0 grid md:grid-cols-12 gap-2 md:gap-6 items-baseline">
                <span className="md:col-span-3 font-mono-d text-xs text-[var(--ink-3)]">{new Date(r.created_at).toLocaleDateString()}</span>
                <span className="md:col-span-6 font-serif-d text-xl truncate group-hover:underline underline-offset-4">{r.filename}</span>
                <span className="md:col-span-3 text-sm text-[var(--ink-2)]">{TYPE_LABELS[r.doc_type]} / <span style={{ color: "var(--red)" }}>{red} high</span></span>
              </Link>
              <button onClick={() => remove(r.id)} className="text-[var(--ink-3)] hover:text-[var(--red)]" data-testid={`delete-review-${r.id}`} aria-label="Delete review">
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
